import { decodeHtmlEntities } from './html';

const SEP_PATTERN = /(?:\s*(?:[|¦｜]|[-–—−]|\u00b7|\u2022|\u2219|\.|\/|\\|:)\s*)/;
// Restrictive separator pattern limited to pipe and dash variants (used for brands
// like "Microsoft AI" that frequently appear as subjects in headlines e.g. "vs. Microsoft AI").
const PIPE_DASH_SEP_PATTERN = /(?:\s*(?:[|¦｜]|[-–—−])\s*)/;

const SUFFIX_PATTERNS: RegExp[] = [
  // <dot> GitHub: e.g. "· GitHub", "• GitHub", ". GitHub", "| GitHub", "- GitHub"
  new RegExp(`${SEP_PATTERN.source}GitHub\\s*$`, 'i'),
  // | OpenAI API: e.g. "| OpenAI API", "- OpenAI API"
  new RegExp(`${SEP_PATTERN.source}OpenAI\\s+API\\s*$`, 'i'),
  // | Google Cloud Blog: e.g. "| Google Cloud Blog", "- Google Cloud Blog"
  new RegExp(`${SEP_PATTERN.source}Google\\s+Cloud\\s+Blog\\s*$`, 'i'),
  // | Autumn: e.g. "| Autumn", "- Autumn"
  new RegExp(`${SEP_PATTERN.source}Autumn\\s*$`, 'i'),
  // - Reware Labs: e.g. "- Reware Labs", "— Reware Labs", "| Reware Labs"
  new RegExp(`${SEP_PATTERN.source}Reware\\s+Labs\\s*$`, 'i'),
  // | Meta AI Research: e.g. "| Meta AI Research", "- Meta AI Research"
  new RegExp(`${SEP_PATTERN.source}Meta\\s+AI\\s+Research\\s*$`, 'i'),
  // | Microsoft AI: e.g. "| Microsoft AI", "- Microsoft AI"
  // Restricted to pipe and dash separators because "Microsoft AI" is often the headline
  // subject (e.g. "Google DeepMind vs. Microsoft AI", "Exclusive: Microsoft AI").
  new RegExp(`${PIPE_DASH_SEP_PATTERN.source}Microsoft\\s+AI\\s*$`, 'i'),
  // \ Anthropic: anthropic.com page titles end in " \ Anthropic", claude.com ones in
  // "| Claude by Anthropic"; also "| Anthropic", "- Anthropic".
  // Restricted to backslash, pipe and dash separators because "Anthropic" is often the headline
  // subject (e.g. "OpenAI vs. Anthropic", "Pentagon: Anthropic"), and whitespace is required
  // before the separator so "anti-Anthropic" keeps its prefix.
  /\s+(?:\\|[|¦｜]|[-–—−])\s*(?:Claude\s+by\s+)?Anthropic\s*$/i,
];

export function stripTitleSuffixes(title: string): string {
  if (!title) return '';
  let current = title.trim();
  if (!current) return '';

  let changed = true;
  while (changed) {
    changed = false;
    for (const pattern of SUFFIX_PATTERNS) {
      const match = pattern.exec(current);
      if (match && match.index !== undefined) {
        const prefix = current.slice(0, match.index).trim();
        if (prefix) {
          current = prefix;
          changed = true;
          break;
        }
      }
    }
  }
  return current;
}

/**
 * Format a story title for display on feed surfaces.
 * Decodes HTML entities and strips unwanted publisher branding suffixes.
 */
export function formatStoryTitle(rawTitle?: string | null): string {
  const decoded = decodeHtmlEntities(rawTitle || '').trim();
  const stripped = stripTitleSuffixes(decoded);
  return stripped || '(Untitled)';
}
